import requests from "@/common/fetch";
import { Result, mockResponse } from "../common";
import { toCamelCase, toUnderCase } from "@/common/util/transform";
import * as I from "./interface";
import mockData from "./mock.json";

/** 获取店铺有权限查看的类目信息 */
export const queryCategoryInfo = (
  params: I.MallId
): Result<I.QueryCategoryInfoResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/searchAnalysis/queryCategoryInfo",
      toUnderCase(params)
    )
  );
};

/** 查询行业趋势 */
export const queryIndustryTrend = (
  params: I.QueryIndustryTrendParam
): Result<I.QueryIndustryTrendResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/searchAnalysis/queryIndustryTrend",
      toUnderCase(params)
    )
  );
};

/** 查询关键词词排行榜 */
export const queryKeywordRank = (
  params: I.QueryKeywordRankParam
): Result<I.QueryKeywordRankResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/searchAnalysis/queryKeywordRank",
      toUnderCase(params)
    )
  );
};

/** 查询搜索词趋势 */
export const queryKeywordTrend = (
  params: I.QueryKeywordTrendParam,
  isMock?: boolean
): Result<I.QueryKeywordTrendResult> => {
  return !isMock
    ? toCamelCase(
        requests.post(
          "/mmsapi/brandbank/searchAnalysis/queryKeywordTrend",
          toUnderCase(params)
        )
      )
    : mockResponse(mockData.QueryKeywordTrendResult);
};

/** 搜索词人群画像 */
export const queryKeywordPortra = (
  params: I.QueryKeywordPortraParams
): Result<I.QueryKeywordPortraResult> => {
  return toCamelCase(
    requests.post(
      "/mmsapi/brandbank/searchAnalysis/queryKeywordPortra",
      toUnderCase(params)
    )
  );
};
